// GSAP defaults — loaded deferred after vendor.min.js + animations.min.js
gsap.defaults({ ease: Power4.easeOut });
gsap.config({ nullTargetWarn: false });
gsap.registerPlugin(ScrollTrigger);
